app.service("tooltip", function (html, front, broker) {
	let $self, $btnClose, $body, $currentElement;

	function setElements() {
		$body = $('body');
		$self = $('<div id="tooltip"></div>');
		$btnClose = $('<button class="btn-hide-tooltip"></button>');
		$('body').append($self);
	}

	function setEventOnElement(){
		$('.js-show-tooltip-and-stop').click(function(event){
			if (front.getBrakepoint() === 'mobile') {
				$currentElement = $(this);
				toggleTooltip();
				event.preventDefault();
				event.stopPropagation();
			}
		})
	}

	function setEvents() {
		$(window).resize(() => {
			if (html.has('show-tooltip')) {
				setPosition();
			}
		});
		
		$('body')
			.on('click', function (e) {
				if (html.has('show-tooltip') && !e.target.closest('#tooltip')) {
					hideTooltip();
				}
			})
			.on('mouseover', '.js-show-tooltip, .js-show-tooltip-and-stop', function () {
				if (front.getBrakepoint() === 'desktop') {
					$currentElement = $(this);
					showTooltip();
				}
			})
			.on('click', '.js-show-tooltip', function (e) {
				if (front.getBrakepoint() === 'mobile') {
					$currentElement = $(this);
					toggleTooltip();
					e.stopPropagation();
				}
			})
			.on('mouseleave', '.js-show-tooltip, .js-show-tooltip-and-stop, #tooltip', function (e) {
				if (!e.relatedTarget.closest('#tooltip') && !e.relatedTarget.closest('.js-show-tooltip')) {
					hideTooltip();
				}
			});
		$($self).on('click', '.btn-hide-tooltip', () => {
			hideTooltip();
		});
	}

	function toggleTooltip() {
		!html.has('show-tooltip') ? showTooltip() : hideTooltip();
	}

	function showTooltip() {
		const id = $currentElement.data('tooltip-id');
		const message = id ? $(`#${id}`).html() : $('.tooltip-message', $currentElement).html();
		setContent(message);
		setPosition();
		html.add('show-tooltip');
	}

	function hideTooltip() {
		html.remove('show-tooltip');
	}

	function setPosition() {
		const arrowWidth = 10;
		const padding = 16;
		let arrowLeftPosition = 18;
		let left, top;

		if ($currentElement.length) {
			const bodyRect = $body[0].getBoundingClientRect();
			const tooltipRect = $self[0].getBoundingClientRect();
			const currentElementRect = $currentElement[0].getBoundingClientRect();

			if (currentElementRect.right + padding < tooltipRect.width) {
				left = 0;
			} else {
				left = currentElementRect.right + padding - tooltipRect.width;
			}

			if ($currentElement.hasClass('show-tooltip-text')) {
				arrowLeftPosition = currentElementRect.right - left - padding;
			} else {
				arrowLeftPosition = currentElementRect.right - left - currentElementRect.width / 2 - arrowWidth / 2;
			}

			$self.removeClass('under');
			if (currentElementRect.top < tooltipRect.height) {
				top = currentElementRect.top + window.pageYOffset + currentElementRect.height;
				$self.addClass('under');
			} else {
				top = currentElementRect.top + window.pageYOffset - tooltipRect.height;
			}

			$self.css({ top: top, left: left });
			$self[0].style.setProperty('--arrow-left-position', `${arrowLeftPosition}px`);
		}
	}

	function setContent(message) {
		$self.html(message);
		$self.prepend($btnClose);
	}
	let isOneInit = false;
	function init() {
		if(!isOneInit){
			isOneInit = true;
			setElements();
			setEvents();
			setEventOnElement();
			broker.on('RELOAD_CART_SUCCESS', setEventOnElement);
		}
	}

	return {
		init,
	};
});
